import { appConfig, headerConfig, refineHeader } from "../../config";

export const promoService = {
  add_promo,
  getPromoList,
  deletePromo,
  getPromoDetails,
  update_promo
};

function add_promo(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}promo/addPromoCode`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getPromoList(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}promo/list`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function deletePromo(promoIDParam) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}promo/delete/${promoIDParam}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getPromoDetails(promoIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}promo/detail/${promoIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function update_promo(postData) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}promo/edit`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/promoService.js